"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LockoutStatusType = exports.PunchModalType = void 0;
var PunchModalType;
(function (PunchModalType) {
    PunchModalType["PUNCH_CORRECTION"] = "punchCorrection";
    PunchModalType["MISSED_PUNCH"] = "missedPunch";
    PunchModalType["PUNCH_EDIT"] = "punchEdit";
})(PunchModalType = exports.PunchModalType || (exports.PunchModalType = {}));
var LockoutStatusType;
(function (LockoutStatusType) {
    LockoutStatusType["OK"] = "OK";
    LockoutStatusType["WARNING"] = "WARNING";
    LockoutStatusType["LOCKED_OUT"] = "LOCKED_OUT";
})(LockoutStatusType = exports.LockoutStatusType || (exports.LockoutStatusType = {}));
